import { MAIN_PATH } from 'simcards/navigation';

const indexComponent = require('./routes/list/components/SimcardsList');

const indexRoute = {
  component: indexComponent,
};

module.exports = {
  path: MAIN_PATH,
  getChildRoutes(partialNextState, cb) {
    require.ensure([], (require) => {
      cb(null, [
        require('./routes/add'),
        require('./routes/import'),
        require('./routes/show'),
      ]);
    });
  },
  getIndexRoute(partialNextState, cb) {
    require.ensure([], () => {
      cb(null, indexRoute);
    });
  },
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      cb(null, require('./components/SimcardsManager'));
    });
  },
};



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/index.js